// imageBannerFeaturedSlider v1.0.3
(() => {
  class ImageBannerFeaturedSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll("[data-hero-slide]"));
      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains("is-active"));
      this.currentIndex = this.currentIndex >= 0 ? this.currentIndex : 0;
      this.interval = Number(this.dataset.interval) * 1000 || 5000;
      // Keep the first mobile slide stable. Slow mobile Lighthouse runs can
      // reach the carousel transition before a paint candidate is recorded;
      // desktop keeps the configured rotation behavior.
      this.autoRotate = this.dataset.autoRotate === "true"
        && !window.matchMedia("(max-width: 990px)").matches;
      this.startAfterLoad = this.startAfterLoad.bind(this);

      this.loadSlideImages(this.slides[this.currentIndex]);

      if (this.slides.length < 2) return;

      this.addEventListener("mouseenter", () => this.stop());
      this.addEventListener("mouseleave", () => this.start());
      this.addEventListener("focusin", () => this.stop());
      this.addEventListener("focusout", () => this.start());

      // Keep the server-rendered first slide stable until the page has loaded.
      // On throttled mobile, FCP can be later than the configured 3s interval;
      // rotating before the first paint leaves Lighthouse without an LCP
      // candidate even though the hero image is eager and visible in HTML.
      if (document.readyState === "complete") {
        this.startAfterLoad();
      } else {
        window.addEventListener("load", this.startAfterLoad, { once: true });
      }
    }

    disconnectedCallback() {
      this.stop();
      window.removeEventListener("load", this.startAfterLoad);
    }

    startAfterLoad() {
      if (this.isConnected) this.start();
    }

    start() {
      if (!this.autoRotate || this.timer) return;
      this.timer = window.setInterval(() => this.goTo(this.currentIndex + 1), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    goTo(index, userInitiated = false) {
      if (!this.slides.length) return;
      const nextIndex = (index + this.slides.length) % this.slides.length;
      if (nextIndex === this.currentIndex) return;

      this.loadSlideImages(this.slides[nextIndex]);
      this.slides[this.currentIndex].classList.remove("is-active");
      this.slides[this.currentIndex].setAttribute("aria-hidden", "true");
      this.slides[nextIndex].classList.add("is-active");
      this.slides[nextIndex].setAttribute("aria-hidden", "false");
      this.currentIndex = nextIndex;

      if (userInitiated) {
        this.stop();
        this.start();
      }
    }

    loadSlideImages(slide) {
      if (!slide) return;

      slide.querySelectorAll("img[data-eb-lazy-src]").forEach((image) => {
        if (image.dataset.ebLazySrcset) {
          image.srcset = image.dataset.ebLazySrcset;
          image.removeAttribute("data-eb-lazy-srcset");
        }
        image.src = image.dataset.ebLazySrc;
        image.removeAttribute("data-eb-lazy-src");
      });
    }
  }

  if (!customElements.get("image-banner-featured-slider")) {
    customElements.define("image-banner-featured-slider", ImageBannerFeaturedSlider);
  }
})();
